import { type DietaryPropertyKind } from '@sg/graphql-schema';

export type DietaryRestrictionsTypes = Record<DietaryPropertyKind, boolean>;
